import { createStyles, emphasize, Theme } from '@mui/material'

const styles = ({ spacing, palette }: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      height: 250,
    },
    input: {
      display: 'flex',
      padding: 0,
      height: '100%',
    },
    menuOption: {
      height: 'auto',
      whiteSpace: 'normal',
    },
    valueContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      flex: 1,
      alignItems: 'center',
      paddingRight: spacing(2),
    },
    chip: {
      marginRight: spacing(0.5),
      marginBottom: spacing(0.5),
    },
    chipFocused: {
      backgroundColor: emphasize(palette.mode === 'light' ? palette.grey[300] : palette.grey[700], 0.08),
    },
    disabledChip: {
      backgroundColor: palette.error.main,
    },
    optionsMessage: {
      padding: spacing(1, 2),
    },
    singleValue: {
      fontSize: 16,
    },
    placeholder: {
      position: 'absolute',
      left: 2,
      fontSize: 16,
    },
    paper: {
      position: 'absolute',
      zIndex: 1,
      marginTop: spacing(),
      left: 0,
      right: 0,
    },
    iconButton: {
      padding: spacing(0.5),
      margin: spacing(0.5),
    },
    loading: {
      margin: spacing(1.25),
    },
    indicatorSeparator: {
      alignSelf: 'stretch',
      backgroundColor: 'rgb(204, 204, 204)',
      marginBottom: spacing(),
      marginTop: spacing(),
      width: 1,
      boxSizing: 'border-box',
    },
  })

export default styles
